export default defineNuxtPlugin({
  name: 'openfeature',
  setup: async (nuxtApp) => {
    const { registerFeatureFlagProvider } = await import(
      '../openfeature/client'
    )
    const { configCatSdkKey } = useRuntimeConfig().public
    const client = await registerFeatureFlagProvider(String(configCatSdkKey))
    nuxtApp.provide('openfeature', client)
  },
})
